import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, useStore } from "@nuxtjs/composition-api";
import { storeToRefs } from "pinia";

import { useAmplitude, useTranslate, useVuetify } from "@/composables";
import { useCreatorShopPostsStore } from "@/store/creator-shop-posts";
import { getExperimentsStore } from "@/store/experiments";
import { FEATURE_FLAG_ACTIVE, FLAG_CREATOR_SHOP_SEARCH } from "@/utils/experiments/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatorShopSearch',
  props: {
  selectedTab: { type: String, required: true },
},
  emits: ["search"],
  setup(__props, { emit: emits }: { emit: ({
  (e: "search", value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const store = useStore();
const amplitude = useAmplitude();
const { t } = useTranslate();
const vuetify = useVuetify();

const creatorShopPostsStore = useCreatorShopPostsStore();
const experimentsStore = getExperimentsStore(store);

const inputModel = ref("");
const { totalNumberOfPosts } = storeToRefs(creatorShopPostsStore);

const isCreatorShopSearchEnabled = computed(
  () => experimentsStore.flag(FLAG_CREATOR_SHOP_SEARCH)?.value === FEATURE_FLAG_ACTIVE,
);
const isPostTab = computed(() => props.selectedTab === "posts");
const inputPlaceholder = computed(() => {
  const isCreatorShopSearchEnabledValue = isCreatorShopSearchEnabled.value;
  const total = totalNumberOfPosts.value.toString();
  const isPostTabValue = isPostTab.value;
  if (isPostTabValue) {
    if (isCreatorShopSearchEnabledValue) {
      return t("Search all posts").value;
    }
    return t("Search all {totalLtks} posts", { totalLtks: total }).value;
  }
  return t("Search all products").value;
});

const scrollInputIntoView = () => {
  if (process.server) {
    return;
  }

  const feedSelector = isPostTab.value ? "#post-feed" : "#product-feed";
  const tabNavigation = 48;
  const searchInputDesktop = 84;
  const feedTop = (document.querySelector(feedSelector) as HTMLElement)?.offsetTop ?? 0;
  const scrollTargetTop = vuetify.breakpoint.mdAndUp
    ? feedTop + tabNavigation + searchInputDesktop
    : feedTop + tabNavigation;
  window.scrollTo({ top: scrollTargetTop });
};

const onFocus = () => {
  amplitude?.sendEvent(
    "/ltk-keyword-search-shop/begin",
    isPostTab.value
      ? {
          "referring-component": "creator shop post feed",
          "creator-shop-tab": "posts",
        }
      : {
          "referring-component": "creator shop product feed",
          "creator-shop-tab": "products",
        },
  );
};

const onSearch = (value = "") => {
  emits("search", value);
  scrollInputIntoView();
};

const onSearchEnter = () => {
  onSearch(inputModel.value);
};

const onSearchClear = () => {
  onSearch("");
};

return { __sfc: true,props, emits, store, amplitude, t, vuetify, creatorShopPostsStore, experimentsStore, inputModel, totalNumberOfPosts, isCreatorShopSearchEnabled, isPostTab, inputPlaceholder, scrollInputIntoView, onFocus, onSearch, onSearchEnter, onSearchClear }
}

})